import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { adminapi } from "../../ApiNames";

type Nullable<T> = T | null;

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data
})

export const fetchdata = (uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:uid};
            const apiname = adminapi.adfundmanager
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
}